import { intlnumberFormat } from '@patrianna/shared-utils/numbers'

import classes from './styles.module.scss'

type Props = {
  oldPrice?: number
}

export default function OfferOldPrice({ oldPrice }: Props) {
  if (!oldPrice) {
    return null
  }

  return (
    <span className={classes.root}>{intlnumberFormat(oldPrice, 'en-US', { style: 'currency', currency: 'USD' })}</span>
  )
}
